<template>
  <swiper-container ref="swiperEl" init="false" class="group rounded-lg">
    <div
      slot="container-start"
      class="nav-prev absolute bottom-0 left-0 top-0 z-10 flex w-16 cursor-pointer items-center justify-center rounded-l-sm bg-slate-darker2 bg-opacity-50 text-white opacity-0 transition duration-300 group-hover:opacity-100"
    >
      <UiIcon icon="sliderArrowLeft"></UiIcon>
    </div>

    <div
      slot="container-start"
      class="nav-next absolute bottom-0 right-0 top-0 z-10 flex w-16 cursor-pointer items-center justify-center rounded-l-sm bg-slate-darker2 bg-opacity-50 text-white opacity-0 transition duration-300 group-hover:opacity-100"
    >
      <UiIcon icon="sliderArrowRight"></UiIcon>
    </div>

    <swiper-slide v-for="(slide, i) in slides" :key="i">
      <SolutionsCarouselSlide
        v-bind="slide"
        @play="playVideo"
      ></SolutionsCarouselSlide>
    </swiper-slide>
  </swiper-container>
</template>

<script setup lang="ts">
import SolutionsCarouselSlide from '~/components/sections/sliderSection/SolutionsCarouselSlide.vue';
import { useSwiperElement } from '~/composables';

interface Props {
  slides?: any[];
}

interface Emits {
  (e: 'slide-change', data: number): void;
  (e: 'play-video', data: string): void;
  (e: 'init', data: any): void;
}

withDefaults(defineProps<Props>(), {
  slides: () => [],
});

const emit = defineEmits<Emits>();

const swiperOptions = {
  observer: true,
  navigation: {
    prevEl: '.nav-prev',
    nextEl: '.nav-next',
    disabledClass: 'group-hover:opacity-50 group-hover:hover:opacity-75',
  },
  on: {
    init: (swiper: any) => emit('init', swiper),
    activeIndexChange: (swiper: any) =>
      emit('slide-change', swiper.activeIndex),
  },
};

const swiperEl = useSwiperElement(swiperOptions);

const playVideo = (videoId?: string) => {
  if (videoId) emit('play-video', videoId);
};
</script>
